var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import InputFormik from '@src/components/Atoms/Formik/Input/InputFormik';
import MultiSelectFormik from '../../Formik/MultiSelect/MultiSelectFormik';
import { useState, useEffect } from 'react';
import { useSocialMedia } from '@src/app/pages/SocialMediaPage/SocialMedia/SocialMedia.hooks';
import { useDebounce } from 'use-debounce';
import { checkProfiles } from '@src/app/pages/TalentPage/TalentForm/TalentForm.requests';
import styles from '@src/components/molecules/Talent/Form/TalentForm.module.scss';
var ProfileForm = function (_a) {
    var _b;
    var useForm = _a.useForm, idForEdit = _a.idForEdit;
    // const socialMedia = JSON.parse(userInformation).socialMedias
    var _c = useSocialMedia(), socialMedia = _c.socialMedia, isLoadingSocialMedia = _c.isLoading, errorSocialMedia = _c.error;
    var _d = useState(''), selectedSocialMediaValue = _d[0], setSelectedSocialMediaValue = _d[1];
    var _e = useState([]), selectedSocialMedia = _e[0], setSelectedSocialMedia = _e[1];
    var _f = useState(''), profileResult = _f[0], setProfileResult = _f[1];
    var _g = useState(), isProfileErr = _g[0], setIsProfileErr = _g[1];
    var debouncedValue = useDebounce(useForm.values.profileName, 1000)[0];
    var getProfileStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_1, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, checkProfiles(useForm.values.profileName, selectedSocialMediaValue)];
                case 1:
                    data = (_a.sent()).data;
                    if (data.message === 'Success') {
                        setProfileResult('Profile isnt available');
                        setIsProfileErr(true);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    response = error_1.response;
                    if (response) {
                        setProfileResult('Profile is available');
                        setIsProfileErr(false);
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var optionSocialMedias = socialMedia &&
        socialMedia.length > 0 &&
        socialMedia.map(function (sosmed) { return ({
            label: sosmed.name,
            value: sosmed.pubId,
        }); });
    var onChangeSocialMedia = function (e) {
        setSelectedSocialMediaValue(e.value);
        useForm.values.socialMediaPubId = e.value;
        setSelectedSocialMedia(e);
    };
    var socialMediaOnEdit = socialMedia &&
        socialMedia.length > 0 &&
        socialMedia
            .filter(function (socialMedia) { return socialMedia.pubId === useForm.values.socialMediaPubId; })
            .map(function (obj) { return ({
            label: obj.name,
            value: obj.pubId,
        }); });
    useEffect(function () {
        socialMediaOnEdit && setSelectedSocialMedia(socialMediaOnEdit); //set socialMedia on edit
    }, [socialMedia]);
    useEffect(function () {
        getProfileStatus();
    }, [debouncedValue]);
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: 'mb-3' }, { children: _jsx("div", { children: optionSocialMedias && (_jsx(MultiSelectFormik, { name: 'socialMediaPubId', label: 'Sosial Media', formik: useForm, isMulti: false, options: optionSocialMedias, value: selectedSocialMedia, onchange: onChangeSocialMedia, isRequired: true, isDisabled: idForEdit ? true : false })) }) })), _jsx("div", __assign({ className: 'mb-3' }, { children: _jsxs("div", { children: [_jsx(InputFormik, { label: 'Nama Profile', type: 'text', placeholder: 'Nama Profile', name: 'profileName', formik: useForm, isRequired: true }), ((_b = useForm.errors) === null || _b === void 0 ? void 0 : _b.profiles) && (_jsx("div", __assign({ className: 'fv-plugins-message-container mb-7', style: { marginTop: '-15px' } }, { children: _jsx("div", __assign({ className: 'fv-help-block' }, { children: _jsx("span", __assign({ role: 'alert' }, { children: useForm.profileName })) })) }))), useForm.values.profileName && profileResult && profileResult !== '' && (_jsx("p", __assign({ className: "".concat(isProfileErr ? 'text-danger' : 'text-success', " ").concat(styles['profile-status-message']) }, { children: profileResult })))] }) })), _jsx("div", __assign({ className: 'mb-5' }, { children: _jsx("div", { children: _jsx(InputFormik, { label: 'Link Profile', type: 'text', placeholder: 'Link Profile', name: 'profileLink', formik: useForm, isRequired: true }) }) }))] }));
};
export default ProfileForm;
